// extracted by mini-css-extract-plugin
module.exports = {"azure_mp_container":"AzureMediaPlayer_azure_mp_container__1IFVv","video":"AzureMediaPlayer_video__3RKVK"};